import { ExtractPropTypes } from 'vue'

export const newPaymentMethodProps = {
  modelValue: {
    type: String,
    default: 'wechat'
  },
}
export type NewPaymentMethodProps = Partial<ExtractPropTypes<typeof newPaymentMethodProps>>